module.exports = __webpack_public_path__ + "img/firefox.cc2164dc.png";